import { put, select, takeLatest } from 'redux-saga/effects';
import requestWrapper from 'utils/requestWrapper';
import history from 'utils/history';
import { LOAD_ABSENCE, CHANGE_ABSENCE, DELETE_ABSENCE } from './constants';

import {
  loadAbsenceError,
  loadAbsenceSuccess,
  changeAbsenceError,
  changeAbsenceSuccess,
  deleteAbsenceSuccess,
  deleteAbsenceError,
} from './actions';

import { notification } from 'antd';


export function* loadAbsence(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(localStorage.getItem('schoolinked_user'));
    const { id } = action;

    // we get the campaigns linked to the absence
    const absenceData = yield requestWrapper('GET', `absence/${id}`, '', currentUser.token);

    if (!absenceData) {
      yield put(loadAbsenceSuccess(false));
    } else {
      yield put(loadAbsenceSuccess(absenceData));
    }
  } catch (error) {
    yield put(loadAbsenceError(error));
  }
}



export function* changeAbsence(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(localStorage.getItem('schoolinked_user'));
    const { absenceData } = action;
    let changedAbsence = false,
      isNew = !absenceData?._id;

    if (isNew) {
      changedAbsence = yield requestWrapper(
        'POST',
        'absence/new/',
        absenceData,
        currentUser.token
      );
      notification.success({ message: 'Établi' });
    } else {
      changedAbsence = yield requestWrapper('PATCH', 'absence/', absenceData, currentUser.token);
      notification.success({ message: 'Mis à jour' });
    }
    if (!changedAbsence) {
      yield put(changeAbsenceSuccess(false));
    } else {
      // if new we update the url, item props will be updated
      if (isNew) {
        history.push({ pathname: `/absences/${changedAbsence?._id}` });
      }
      yield put(changeAbsenceSuccess(changedAbsence));
    }
  } catch (error) {
    yield put(changeAbsenceError(error));
  }
}

export function* deleteAbsence(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(localStorage.getItem('schoolinked_user'));
    const { id } = action;

    const deleteAbsence = yield requestWrapper(
      'PATCH',
      `absence/remove`,
      {
        _id: id,
        active: false,
      },
      currentUser.token,
    );

    if (deleteAbsence) {
      yield put(deleteAbsenceSuccess());
    }
  } catch (error) {
    yield put(deleteAbsenceError(error));
  }
}

export default function* absenceSaga() {
  yield takeLatest(LOAD_ABSENCE, loadAbsence);
  yield takeLatest(CHANGE_ABSENCE, changeAbsence);
  yield takeLatest(DELETE_ABSENCE, deleteAbsence);
}
